import * as React from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
import styled from 'styled-components';
import { AutoScaledImage } from '@helpcenter/auto-scaled-image';
import { FormattedMessage } from 'react-intl';
import { IconCardLayout } from 'view/layout/icon-card-layout';
import Lozenge from '@atlaskit/lozenge/lozenge';
import { token } from '@atlaskit/tokens';
import i18n from './messages';

export interface Props {
	icon: React.ReactNode;
	name: string;
	email?: string;
	isNew?: boolean;
}

const UserPickerItem: React.FunctionComponent<Props> = ({ icon, name, email, isNew }) => {
	const content = email ? `${name} (${email})` : name;
	const iconComponent = typeof icon === 'string' ? <AutoScaledImage src={icon} alt="" /> : icon;

	return (
		<UserPickerItemSectionFlex>
			<FlexIconCardLayout
				leftIcon={iconComponent}
				content={content}
				iconSize={16}
				iconMargin={8}
				padding={0}
			/>
			{isNew && (
				<Lozenge appearance="discovery">
					<FormattedMessage {...i18n.newUserLozengeText} />
				</Lozenge>
			)}
		</UserPickerItemSectionFlex>
	);
};

export default UserPickerItem;

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const UserPickerItemSectionFlex = styled.div`
	display: inline-flex;
	align-items: baseline;
	gap: ${token('space.100', '8px')};
	grid-area: 1 / 1 / 2 / 3;
`;

// Constrains the name/email layout so it shrinks instead of pushing the lozenge off-line.
// Applied directly on IconCardLayout (via its forwarded className) rather than a parent-scoped
// nested selector, per go/ui-styling-standard.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const FlexIconCardLayout = styled(IconCardLayout)`
	flex: 0 1 auto;
	width: auto;
`;
